import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {UserLogged} from '../../models/userLogged';

@Component({
  selector: 'app-view-announcement',
  templateUrl: './view-announcement.component.html',
  styleUrls: ['./view-announcement.component.scss']
})
export class ViewAnnouncementComponent implements OnInit {
  public announcementUuid: string;
  public loggedInUser: UserLogged;

  constructor(
    private route: ActivatedRoute,
    protected utilsService: UtilsService,
    private _router: Router,
    public authenticationService: AuthenticationService,) {
  }

  ngOnInit() {
    this.loggedInUser = this.authenticationService.userCurrent;
    this.route.paramMap.subscribe(params => {
      this.announcementUuid = params.get('uuid');
      if (this.announcementUuid) {
        const userChoicesFiltersDefaultAnnouncementLog = {
          'subject': null,
          'message': null,
          'fromMail': null,
          'user': null,
          'sentDateFrom': null,
          'sentDateTo': null,
          'uuid': null,
        };
        const userChoicesActiveFilters = this.utilsService.loadUserPref('announcementLogFilter', userChoicesFiltersDefaultAnnouncementLog);
        userChoicesActiveFilters.uuid = [this.announcementUuid];
        this.utilsService.saveUserData('announcementLogFilter', userChoicesActiveFilters);
        this._router.navigate(['/' + this.loggedInUser.company.uniqid + '/announcementLog']);
      } else {
        this._router.navigate(['/' + this.loggedInUser.company.uniqid + '/announcementLog']);
      }
    });
  }

}
